"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var Observable_1 = require("rxjs/Observable");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var DslsHttpService = /** @class */ (function () {
    function DslsHttpService(applicationPropertiesService, http) {
        this.applicationPropertiesService = applicationPropertiesService;
        this.http = http;
    }
    DslsHttpService_1 = DslsHttpService;
    DslsHttpService.prototype.getDsls = function () {
        var _this = this;
        return this.getServiceUrl(DslsHttpService_1.GET_LEVELS_URL)
            .flatMap(function (url) { return _this.http.get(url); })
            .catch(DslsHttpService_1.handleError);
    };
    DslsHttpService.prototype.getDsl = function (id) {
        var _this = this;
        var placeHolders = new Map()
            .set("{id}", idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(id).toString());
        return this.getServiceUrl(DslsHttpService_1.GET_LEVEL_URL, placeHolders)
            .flatMap(function (url) { return _this.http.get(url); })
            .catch(DslsHttpService_1.handleError);
    };
    DslsHttpService.prototype.addDsl = function (dsl) {
        var _this = this;
        return this.getServiceUrl(DslsHttpService_1.ADD_LEVEL_URL)
            .flatMap(function (url) { return _this.http.post(url, dsl); })
            .catch(DslsHttpService_1.handleError);
    };
    DslsHttpService.prototype.updateDsl = function (dsl) {
        var _this = this;
        return this.getServiceUrl(DslsHttpService_1.UPDATE_LEVEL_URL)
            .flatMap(function (url) { return _this.http.put(url, dsl); })
            .catch(DslsHttpService_1.handleError);
    };
    DslsHttpService.prototype.deleteDsl = function (id) {
        var _this = this;
        var palaceHolders = new Map()
            .set("{id}", idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(id).toString());
        return this.getServiceUrl(DslsHttpService_1.DELETE_LEVEL_URL, palaceHolders)
            .flatMap(function (url) { return _this.http.delete(url); })
            .catch(DslsHttpService_1.handleError);
    };
    DslsHttpService.prototype.getDslsRules = function () {
        var _this = this;
        return this.getServiceUrl(DslsHttpService_1.GET_LEVEL_RULES_URL)
            .flatMap(function (url) { return _this.http.get(url); })
            .catch(DslsHttpService_1.handleError);
    };
    DslsHttpService.prototype.getDslsRule = function (id) {
        var _this = this;
        var placeHolders = new Map()
            .set("{id}", idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(id).toString());
        return this.getServiceUrl(DslsHttpService_1.GET_LEVEL_RULE_URL, placeHolders)
            .flatMap(function (url) { return _this.http.get(url); })
            .catch(DslsHttpService_1.handleError);
    };
    DslsHttpService.prototype.getServiceUrl = function (extension, placeHolders) {
        return Observable_1.Observable.fromPromise(this.applicationPropertiesService.getProperty(DslsHttpService_1.POLICY_SERVICE_URL_KEY)
            .then(function (serviceBaseUrl) { return serviceBaseUrl + DslsHttpService_1.POLICY_SERVICE_BASE_PATH + extension; })
            .then(function (url) { return url.replace(/{\w+}/g, function (placeHolder) { return placeHolders.get(placeHolder) || placeHolder; }); }))
            .catch(DslsHttpService_1.handleError);
    };
    DslsHttpService.handleError = function (error) {
        console.error(error);
        return Observable_1.Observable.throw(error);
    };
    DslsHttpService.GET_LEVELS_URL = '';
    DslsHttpService.GET_LEVEL_URL = '/{id}';
    DslsHttpService.ADD_LEVEL_URL = '';
    DslsHttpService.UPDATE_LEVEL_URL = '';
    DslsHttpService.DELETE_LEVEL_URL = '/{id}';
    DslsHttpService.GET_LEVEL_RULES_URL = '/rules';
    DslsHttpService.GET_LEVEL_RULE_URL = '/rules/{id}';
    DslsHttpService.POLICY_SERVICE_URL_KEY = "policy-service-url";
    DslsHttpService.POLICY_SERVICE_BASE_PATH = "/dsls";
    DslsHttpService = DslsHttpService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.HttpClientWrapper])
    ], DslsHttpService);
    return DslsHttpService;
    var DslsHttpService_1;
}());
exports.DslsHttpService = DslsHttpService;
//# sourceMappingURL=dsls-http.service.js.map